// extracted by mini-css-extract-plugin
module.exports = {"seo-text":"seo-blocks_seo-text__yw99c"};